<template>
  <div>
    <!--subPage 상단 Navi-->
    <div class="sub_Navi">
      <ul>
        <li>
          <a class="back" href="javascript:window.history.back();">뒤로</a>
        </li>
        <li>
          <h1>{{ $t("mypage.referralInfo") }}</h1>
        </li>
        <li class="linkBox"></li>
      </ul>
    </div>
    <!--//subPage 상단 Navi :End-->
    <!--subPage -->
    <div v-if="recommendDetail === true">
      <div class="subPage_container" v-if="
        loadDashBoard && dashboard.level != null
      ">
        <div class="referral_wrap">
          <!--나의 실적정보-->
          <div class="referral_infobox referral-fold-wrap">
            <div class="referral_value">
              <h5>
                {{ dashboard.level }}
              </h5>
              <h3 class="num">${{ groupTotal }} USDT</h3>
            </div>
          </div>
          <!--좌우그룹실적-->
          <div class="referral_group">
            <div class="group_box">
              <div class="group--num">
                <img src="@/assets/images/setting/wallet.png" alt="icon" />
                <h5>{{ $t("mypage.leftGroup") }}</h5>
              </div>
              <h3 class="num">${{ dashboard.leftRecord }}</h3>
            </div>
            <div class="group_box">
              <div class="group--num">
                <img src="@/assets/images/setting/wallet.png" alt="icon" />
                <h5>{{ $t("mypage.rightGroup") }}</h5>
              </div>
              <h3 class="num">${{ dashboard.rightRecord }}</h3>
            </div>
          </div>
        </div>
        <div class="referral_data_wrap">
          <h3 class="title">{{ $t("mypage.totalReferral") }}</h3>
          <ul>
            <li>
              <span class="subTxt">{{ $t("mypage.referralNumber") }}</span>
              <span class="count">{{ dashboard.recommendCount }}{{ $t("mypage.person") }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.referralPrice") }}</span>
              <span class="count">${{ dashboard.recommendAmount }} </span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.subNumber") }}</span>
              <span class="count">{{ dashboard.belowCount }}{{ $t("mypage.person") }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.subPrice") }}</span>
              <span class="count">${{ dashboard.belowAmount }}</span>
            </li>
            <div class="form_wrap pt0 pb0">
              <div class="btn_inner right">
                <a id="referralDetail" @click="changeResultState()">
                  {{ $t("mypage.referralDetail") }}
                  <img src="@/assets/images/icon/arrow/arrow-right-white.png" alt="" />
                </a>
              </div>
            </div>  
          </ul>
        </div>

        <Transition name="recommendInfo">
          <div v-if="this.clickResult === true">
            <ResultDetail :recommendList="recommendList" :recommendNum="recommendNum" @getDashboard="getDashboard" />
          </div>
        </Transition>

        <div class="referral_data_wrap bottom">
          <h3 class="title">{{ $t("mypage.totalIncome") }}</h3>
          <ul>
            <li>
              <span class="subTxt">{{ $t("mypage.closingIncome") }}</span>
              <span class="value num">${{ dashboard.closingIncome }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.sharingIncome") }}</span>
              <span class="value num">${{ dashboard.sharingIncome }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.rowlevelIncome") }}</span>
              <span class="value num">${{ dashboard.lowLevelIncome }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.highLevelIncome") }}</span>
              <span class="value num">${{ dashboard.highLevelIncome }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.startBonus") }}</span>
              <span class="value num">${{ dashboard.startBonus }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.promotion") }}</span>
              <span class="value num">${{ dashboard.promotionBonus }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.mvpBonus") }}</span>
              <span class="value num">${{ dashboard.mvpBonus }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.specialBonus") }}</span>
              <span class="value num">${{ dashboard.specialBonus }}</span>
            </li>
            <li>
              <span class="subTxt">{{ $t("mypage.total") }}</span>
              <span class="value yc num">${{ incomeTotal }}</span>
            </li>
            <div class="form_wrap pt0">
              <div class="btn_inner right">
                <a id="bonusDetail" @click="changeBonusState()">
                  {{ $t("mypage.seePeriodBonus") }}
                  <img src="@/assets/images/icon/arrow/arrow-right-white.png" alt="" />
                </a>
              </div>
            </div>
          </ul>
        </div>

        <Transition name="recommendInfo">
          <div v-if="this.clickBonus === true">
            <BonusDetail @getDashboard="getDashboard" />
          </div>
        </Transition>
      </div>

    </div>
    <div class="loading_spinner_trade" v-if="recommendDetail === false">
      <div class="loading_circle_trade"></div>
    </div>
    <!--//subPage_container :End -->
    <!--//subPage :End -->
  </div>
</template>

<script>
import ResultDetail from "@/components/user/recommend/ResultDetail.vue";
import BonusDetail from "@/components/user/recommend/BonusDetail.vue";
import api from "@/api/apiUser";

import { mapState, mapMutations } from "vuex";
import { toggleModal } from "@/utils/modalControll";

export default {
  name: "RecommendInfo",
  data() {
    return {
      loadDashBoard: false,
      recommendList: [], // 실적 상세정보 리스트
      dashboard: [],
      groupTotal: 0,
      incomeTotal: 0,
      recommendNum: [], // 실적 상세정보 숫자 리스트(team minus 비교를 위함)
      recommendDetail: false,
    };
  },
  components: {
    ResultDetail,
    BonusDetail,
  },
  async beforeMount() {
    this.getDashboard();
  },
  computed: {
    ...mapState("user", ["clickResult", "clickBonus"]),
  },
  methods: {
    ...mapMutations("user", ["changeResult", "changeBonus"]),

    toggleModal,
    async getDashboard() {
      // dashboard api get 호출
      try {
        const response = await api.getDashboard();
        if (response.isSuccess) {
          this.loadDashBoard = true;
          const newData = {};

          // 리트리 페이지와 동일하게 반올림 처리
          for (let key in response.data) {
            if (Object.hasOwnProperty.call(response.data, key)) {
              let value = response.data[key];
              if (typeof value === 'number' && value % 1 !== 0) {
                let decimalCount = value.toString().split('.')[1].length;
                if (decimalCount >= 2) {
                  response.data[key] = parseFloat(value.toFixed(2));
                }
              }
            }
          }

          // 숫자 3개마다 쉼표
          for (let key in response.data) {
            if (Object.prototype.hasOwnProperty.call(response.data, key)) {
              let value = response.data[key];
              if (typeof value === "number") {
                value = value.toLocaleString();
              }
              newData[key] = value;
            }
          }
          this.dashboard = newData;


        } else {
          console.error("Error getting dashboard:", response.error);
        }
      } catch (error) {
        console.error("Error get dashboard:", error);
      }
      try {
        let dashboard = this.dashboard;

        // 좌측그룹 + 우측그룹
        let leftRecord = dashboard.leftRecord.replace(/,/g, "");
        let rightRecord = dashboard.rightRecord.replace(/,/g, "");
        let groupTotal = Number(leftRecord) + Number(rightRecord);
        this.groupTotal = groupTotal.toLocaleString();

        // 인컴 합계
        let total = 0;
        let incomes = Object.keys(this.dashboard).reduce(
          (acc, key) => {
            if (key.includes("Income")) acc.incomes.push(key);
            if (key.includes("Bonus")) acc.incomes.push(key);
            return acc;
          },
          { incomes: [] }
        );

        for (let income of incomes.incomes) {
          let total_income = dashboard[income].replace(/,/g, "");
          total += Number(total_income);
        }
        total = Math.round(total * 100) / 100
        this.incomeTotal = total.toLocaleString()
      } catch (error) {
        console.error("Error total:", error);
      }
      // detail페이지 정보
      try {
        const response = await api.getRecommendDetail();
        if (response.isSuccess) {
          this.recommendDetail = true;

          this.recommendNum.push({
            leftWeek: response.data.leftWeeklyRecord,
            leftMonth: response.data.leftMonthlyRecord,
            rightWeek: response.data.rightWeeklyRecord,
            rightMonth: response.data.rightMonthlyRecord,
          });

          const newData = {};

          for (let key in response.data) {
            if (Object.prototype.hasOwnProperty.call(response.data, key)) {
              let value = response.data[key];
              if (typeof value === "number") {
                value = value.toLocaleString();
              }
              newData[key] = value;
            }
          }

          this.recommendList = newData;
        }
      } catch (error) {
        console.error("Error get recommend detail:", error);
      }
    },
    changeResultState() {
      this.changeResult({ state: true });
    },
    changeBonusState() {
      this.changeBonus({ state: true });
    },
  },
};
</script>

<style scoped>
.loading_spinner_trade {
  margin: auto;
  text-align: center;
  padding-left: 15px;
}

.loading_circle_trade {
  margin: 50px auto;
  width: 40px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, var(--primary-color) 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, var(--primary-color));
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

.loading_spinner {
  margin: auto;
  text-align: center;
  padding-top: 100px;
}

.loading_circle {
  margin: 0 auto;
  width: 60px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(farthest-side, #6c1af5 94%, #0000) top / 8px 8px no-repeat,
    conic-gradient(#0000 30%, #6c1af5);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: load 1.5s linear infinite;
}

@keyframes load {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.referral-fold-wrap {
  position: relative;
  overflow: visible;
}

/* referral_img 접힘/펼침 영역 */
.referral_img_panel {
  overflow: hidden;
  flex-shrink: 0;
}

/* 접기/펼치기 버튼 */
.referral-toggle-btn {
  position: absolute;
  left: 0;
  top: 50%;
  z-index: 5;

  width: 22px;
  height: 52px;
  padding: 0;
  border: 0;
  border-radius: 0 12px 12px 0;

  background: rgba(255, 255, 255, 0.13);
  backdrop-filter: blur(8px);
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.22),
    inset 1px 0 0 rgba(255, 255, 255, 0.15);

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transform: translate(-2px, -50%);
  transition: all 0.25s ease;
}

.referral-toggle-btn:active {
  transform: translate(-2px, -50%) scale(0.96);
}

/* 삼각형 */
.referral-toggle-btn span {
  width: 0;
  height: 0;

  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 8px solid rgba(255, 255, 255, 0.78);

  transition: transform 0.25s ease;
}

/* 펼친 상태 */
.referral-toggle-btn.open {
  background: rgba(108, 26, 245, 0.28);
}

.referral-toggle-btn.open span {
  transform: rotate(180deg);
}

/* 펼침 애니메이션 */
.referral-slide-enter-active,
.referral-slide-leave-active {
  transition: all 0.25s ease;
}

.referral-slide-enter-from,
.referral-slide-leave-to {
  max-width: 0;
  opacity: 0;
  transform: translateX(-8px);
}

.referral-slide-enter-to,
.referral-slide-leave-from {
  max-width: 130px;
  opacity: 1;
  transform: translateX(0);
}
</style>
